
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Head from 'next/head';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
// Questions are sourced from real Ahrefs search queries (May 2026), not invented.
// FAQ rich results are deprecated for commercial sites, so the FAQPage JSON-LD
// here is for AI/answer-engine extraction (GEO), not a Google rich result.
const FAQ_KEYS = [
    'q1',
    'q2',
    'q3',
    'q4',
    'q5',
    'q6',
    'q7',
    'q8',
    'q9',
    'q10',
    'q11',
    'q12'
];
function Faq() {
    const { t } = useTranslation('faq');
    const faqs = FAQ_KEYS.map((k, i) => ({
        q: t(k),
        a: t(`a${i + 1}`)
    }));
    const faqJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(({ q, a }) => ({
            '@type': 'Question',
            name: q,
            acceptedAnswer: { '@type': 'Answer', text: a }
        }))
    };
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('meta_title')}</title>
                <meta name="description" content={t('meta_description')}/>
                <meta name="robots" content="all"/>
                <meta property="og:title" content={t('meta_title')}/>
                <meta property="og:description" content={t('meta_description')}/>
                <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqJsonLd)
        }}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('page_title')}</h1>
            <p className="mt-3 text-gray-600">{t('intro')}</p>

            <dl className="mt-6 divide-y divide-gray-200">
                {faqs.map(({ q, a }, i) => (<div key={i} className="py-4">
                        <dt className="text-lg font-semibold text-gray-900">
                            {q}
                        </dt>
                        <dd className="mt-2 text-gray-700">{a}</dd>
                    </div>))}
            </dl>

            <div className="mt-8 flex flex-col gap-2">
                <Link href="/" className="text-[var(--secondary)] underline">
                    {t('cta_wait')}
                </Link>
                <Link href="/parking" className="text-[var(--secondary)] underline">
                    {t('cta_parking')}
                </Link>
                <Link href="/passport-control" className="text-[var(--secondary)] underline">
                    {t('cta_passport')}
                </Link>
            </div>
        </div>);
}
export default Faq;

    async function __Next_Translate__getStaticProps__1a1723ec621__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/faq',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec621__ as getStaticProps }
  